/**
 * Fictional "Rivera family" demo data for the landing-page hero mock.
 * Mirrors the API seed script (apps/api/src/db/seed.ts). No real PII.
 */

export interface DemoMember {
  name: string;
  color: string;
}

export interface DemoEvent {
  title: string;
  time: string;
  member: string;
  /** 0-based weekday column (Mon..Fri) */
  day: number;
  /** vertical slot in the mock column, 0 = top */
  slot: number;
  /** the event card that animates in */
  highlight?: boolean;
}

export const riveraMembers: DemoMember[] = [
  { name: 'Maya', color: '#15a2a2' },
  { name: 'Dev', color: '#1184a7' },
  { name: 'Zoe', color: '#ea515f' },
  { name: 'Ollie', color: '#fea802' },
];

export const riveraWeekEvents: DemoEvent[] = [
  { title: 'Standup', time: '9:30', member: 'Maya', day: 0, slot: 0 },
  { title: 'Client call', time: '11:00', member: 'Dev', day: 0, slot: 1 },
  { title: 'Soccer practice', time: '4:30', member: 'Zoe', day: 1, slot: 1 },
  { title: 'Yoga', time: '6:00', member: 'Maya', day: 1, slot: 2 },
  { title: 'Swim class', time: '4:00', member: 'Ollie', day: 2, slot: 1 },
  { title: 'Dentist — Zoe', time: '10:00', member: 'Maya', day: 2, slot: 0, highlight: true },
  { title: 'Piano lesson', time: '5:00', member: 'Zoe', day: 3, slot: 1 },
  { title: 'Project review', time: '2:00', member: 'Maya', day: 3, slot: 0 },
  { title: 'School pickup', time: '3:00', member: 'Dev', day: 4, slot: 0 },
  { title: 'Art club', time: '3:30', member: 'Ollie', day: 4, slot: 1 },
];

export const riveraChore = {
  title: 'Tidy your room',
  member: 'Ollie',
  points: 25,
};

export function memberColor(name: string): string {
  return riveraMembers.find((m) => m.name === name)?.color ?? '#15a2a2';
}
